import { createFileRoute } from "@tanstack/react-router";
import { appelQueryOptions } from "@modules/appels";
import { AppelFrame, AppelRouteError } from "@modules/appels/views";

// The appel level of the frame: loads the appel once for every step below it, gives the breadcrumb
// its last step (« Cohortes > <cohort> > <appel> ») and shows the not-found state inside the frame
// when the appel is unknown or out of this account's scope.
export const Route = createFileRoute(
  "/_staff-area/cohorts/$cohortId/appels/$appelId"
)({
  loader: async ({ context, params }) => {
    const appel = await context.queryClient.ensureQueryData(
      appelQueryOptions(params.appelId)
    );
    return { crumb: appel.name };
  },
  errorComponent: AppelRouteError,
  component: AppelRoute,
});

function AppelRoute() {
  const { cohortId, appelId } = Route.useParams();
  return <AppelFrame cohortId={cohortId} appelId={appelId} />;
}
